// extracted by mini-css-extract-plugin
export default {"startupbox":"bHD29Czy","bgimg":"pBURQnFj","dibubg":"W0dR_xJr","logoimg":"S6CTzhoC","logo-active":"mCfwfKCE","logocontent":"gBMzyDBs","appname":"d8f1lbl5","url":"jhPnVq5q"};